export function wrapIframes() {
  const frames = document.querySelectorAll('#main iframe');

  frames.forEach(frame => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('embed-container');
    frame.parentNode.insertBefore(wrapper, frame);
    wrapper.appendChild(frame);
  });
}

function init() {
  window.addEventListener('load', () => {
    wrapIframes();
  });
}

export default init();
